import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useTableLayoutEnabled } from '../TableLayout/TableLayout.esm.js';
import '@panwds/icons';
import '@panwds/react-ui';
import 'react-intl';
import '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import 'uuid';
import { FooterCell } from './FooterCell.esm.js';
import { groupColumns } from './HeaderRow.esm.js';

function FooterRow({ appearance = 'primary', footerGroup }) {
    const { selectRowColumn, groupedColumns, leftStickyColumns, generalColumns, rightStickyColumns } = groupColumns(footerGroup.headers);
    const tableLayoutEnabled = useTableLayoutEnabled();
    const className = classNames('tw-box-border tw-bg-white dark:tw-bg-gray-1000', tableLayoutEnabled || appearance === 'secondary'
        ? 'tw-border-r-0'
        : 'tw-border tw-border-r-0 dark:tw-border-gray-950');
    return (React.createElement("div", { ...footerGroup.getFooterGroupProps({ role: 'row' }), className: className },
        !!selectRowColumn.length && (React.createElement("div", { className: "tw-flex" }, selectRowColumn.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!groupedColumns.length && (React.createElement("div", { className: "tw-flex" }, groupedColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!leftStickyColumns.length && (React.createElement("div", { className: "tw-flex" }, leftStickyColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!generalColumns.length && (React.createElement("div", { className: "tw-flex tw-flex-grow" }, generalColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!rightStickyColumns.length && (React.createElement("div", { className: "tw-flex tw-shadow-right dark:tw-shadow-dark-right", style: {
                background: 'inherit',
                position: 'sticky',
                right: 0
            } }, rightStickyColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance })))))));
}

export { FooterRow };
//# sourceMappingURL=FooterRow.esm.js.map
